import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SyncUserQuestionsService } from '../../../../api/api-services/sync-user-questions.service';
import { ISyncSingleUserVm } from '../../../../api/sync-single-user-vm.model';
import { ISyncUserByEmailIm } from '../../../../api/sync-user-by-email-im.model';

@Component({
  selector: 'app-sync-user-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    InputTextModule
  ],
  templateUrl: './sync-user-dialog.component.html',
  styleUrl: './sync-user-dialog.component.scss'
})
export class SyncUserDialogComponent {
  private readonly _dialogRef = inject(DynamicDialogRef);
  private readonly _syncUserQuestionsService = inject(SyncUserQuestionsService);

  protected readonly email = signal<string>('');
  protected readonly loading = signal(false);
  protected readonly result = signal<ISyncSingleUserVm | null>(null);

  startSync(): void {
    const emailValue = this.email().trim();
    
    if (!emailValue) {
      return;
    }

    if (!this.isValidEmail(emailValue)) {
      this.result.set({
        success: false,
        message: 'Nieprawidłowy format adresu email',
        addedQuestionsCount: 0,
        processedUserExamsCount: 0,
        errors: ['Wprowadź poprawny adres email']
      });
      return;
    }

    this.loading.set(true);
    this.result.set(null);

    const input: ISyncUserByEmailIm = { email: emailValue };
    
    this._syncUserQuestionsService.post(input).subscribe({
      next: (response) => {
        this.result.set(response);
        this.loading.set(false);
      },
      error: (err) => {
        this.result.set({
          success: false,
          message: 'Nie udało się zsynchronizować użytkownika',
          addedQuestionsCount: 0,
          processedUserExamsCount: 0,
          errors: [err.message || 'Wystąpił nieoczekiwany błąd']
        });
        this.loading.set(false);
        console.error(err);
      }
    });
  }

  reset(): void {
    this.email.set('');
    this.result.set(null);
  }

  closeDialog(): void {
    this._dialogRef.close(this.result());
  }

  private isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
}
